var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from '../common';
import { SeatCapacityLocationsList } from '../seatCapacity/seatCapacityLocationsList';
/**
 * Advisory "Are you sure?" gate shown when locking a plan whose seat demand exceeds the
 * client/LOB allocation at one or more locations. Lists each exceeded location with the
 * seats available (after other locked plans) vs. the seats this plan requires. Reuses the
 * shared ConfirmDialog so it matches the standard lock confirmation styling.
 */
export var SeatCapacityWarningDialog = function (_a) {
  var open = _a.open,
    locations = _a.locations,
    onClose = _a.onClose,
    onConfirm = _a.onConfirm;
  var t = useTranslation('translation').t;
  return _jsx(ConfirmDialog, {
    open: open,
    onClose: onClose,
    title: t('confirmation.title'),
    cancelButtonText: "cancel",
    confirmButtonText: "continueToLock",
    onConfirm: onConfirm,
    disableBackdropClose: true,
    message: _jsxs(Typography, __assign({
      component: "div",
      sx: {
        color: 'text.primary'
      }
    }, {
      children: [_jsx(SeatCapacityLocationsList, {
        locations: locations
      }), _jsx(Typography, __assign({
        component: "p",
        sx: {
          mt: 1.5
        }
      }, {
        children: t('confirmation.descriptionLockPlan')
      }))]
    }))
  });
};